import { render, staticRenderFns } from "./i-parameter.vue?vue&type=template&id=98558470&scoped=true&"
import script from "./i-parameter.vue?vue&type=script&lang=js&"
export * from "./i-parameter.vue?vue&type=script&lang=js&"
import style0 from "./i-parameter.vue?vue&type=style&index=0&id=98558470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98558470",
  null
  
)

export default component.exports